$(function() {
    var svg   = $('#svg_sellers');
    var inpuState = $('select#input_state');

    if(!svg.length) return

    var $estados = $(svg).find('path');

    var objEstado = {
        "AC": [{
            "nome": "Acre",
            "capital": "Rio Branco"
        }],
        "AL": [{
            "nome": "Alagoas",
            "capital": "Maceió"
        }],
        "AP": [{
            "nome": "Amapá",
            "capital": "Macapá"
        }],
        "AM": [{
            "nome": "Amazonas",
            "capital": "Manaus"
        }],
        "BA": [{
            "nome": "Bahia",
            "capital": "Salvador"
        }],
        "CE": [{
            "nome": "Ceará",
            "capital": "Fortaleza"
        }],
        "DF": [{
            "nome": "Distrito Federal",
            "capital": "Brasília"
        }],
        "ES": [{
            "nome": "Espírito Santo",
            "capital": "Vitória"
        }],
        "GO": [{
            "nome": "Goiás",
            "capital": "Goiânia"
        }],
        "MA": [{
            "nome": "Maranhão",
            "capital": "São Luís"
        }],
        "MT": [{
            "nome": "Mato Grosso",
            "capital": "Cuiabá"
        }],
        "MS": [{
            "nome": "Mato Grosso do Sul",
            "capital": "Campo Grande"
        }],
        "MG": [{
            "nome": "Minas Gerais",
            "capital": "Belo Horizonte"
        }],
        "PR": [{
            "nome": "Paraná",
            "capital": "Curitiba"
        }],
        "PB": [{
            "nome": "Paraíba",
            "capital": "João Pessoa"
        }],
        "PA": [{
            "nome": "Pará",
            "capital": "Belém"
        }],
        "PE": [{
            "nome": "Pernambuco",
            "capital": "Recife"
        }],
        "PI": [{
            "nome": "Piauí",
            "capital": "Terezina"
        }],
        "RJ": [{
            "nome": "Rio de Janeiro",
            "capital": "Rio de Janeiro"
        }],
        "RN": [{
            "nome": "Rio Grande do Norte",
            "capital": "Natal"
        }],
        "RS": [{
            "nome": "Rio Grande do Sul",
            "capital": "Porto Alegre"
        }],
        "RO": [{
            "nome": "Rondônia",
            "capital": "Porto Velho"
        }],
        "RR": [{
            "nome": "Roraima",
            "capital": "Boa Vista"
        }],
        "SC": [{
            "nome": "Santa Catarina",
            "capital": "Florianópolis"
        }],
        "SE": [{
            "nome": "Sergipe",
            "capital": "Aracaju"
        }],
        "SP": [{
            "nome": "São Paulo",
            "capital": "São Paulo"
        }],
        "TO": [{
            "nome": "Tocantins",
            "capital": "Palmas"
        }]
    }
    
    // Active States
    $.each(JSON.parse(sellers_states_active), function(i, val) {

        $(svg).find('#' + val).each(function() {
            var $this = $(this);

            $this.find('path').addClass('active');
        });
    });

    $(svg).on('click', 'path', function(e) {
        e.preventDefault();
        
        var $this = $(this);
        var stateID = $this.parent().attr('id');
        var contentInner = $('.page-template-representantes .box-content .inner');

        $estados.removeClass('show');

        $this.addClass('show');

        $(contentInner).html('');

        var data = {
            'action': 'sellers_by_state',
            'query': sellers_by_state_params.posts,
            'state': $this.parent().attr('id'),
            'stateLabel': objEstado[stateID][0].nome
        }
        
        $.ajax({
            url: sellers_by_state_params.ajaxurl,
            type: 'POST',
            data: data,
            // beforeSend: function(xhr) {
            //     button.text('Carregando...');
            // },
            success: function(data) {

                if(data) {
                    $(contentInner).html(data);
                } else {
                    console.log('Erro');
                }
            }
        });
    });

    $(inpuState).on('change', function() {

        var state = $(this).val();

        if(state == '') {
            return
        }

        $('.page-template-representantes .box-content .inner').html('');

        var data = {
            'action': 'sellers_by_state',
            'query': sellers_by_state_params.posts,
            'state': state,
            'stateLabel': objEstado[state][0].nome
        }
        
        $.ajax({
            url: sellers_by_state_params.ajaxurl,
            type: 'POST',
            data: data,
            success: function(data) {

                if(data) {
                    $('.page-template-representantes .box-content .inner').html(data);
                } else {
                    console.log('Erro');
                }
            }
        });
    });
});